import { useEffect, useState } from "react";

import {
  Button,
  Checkbox,
  Drawer,
  Empty,
  Label,
  Loading,
  Message,
} from "@components";

import { BoxTitles } from "@boxes/BoxTitles";

import { ForEach } from "@components/control-statements";
import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const OriginFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [availableOrigins, setAvailableOrigins] = useState([]);
  const [origins, setOrigins] = useState(node?.data?.origins || []);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  const getFreshNode = () => {
    return {
      ...node,
      data: {
        ...node?.data,
        origins: origins,
        quantity: 0,
      },
    };
  };

  useEffect(() => {
    visible && loadSources();
  }, [visible]);
  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [origins]);

  const loadSources = async () => {
    setLoading(true);
    const sourcesResponse = await OlgaEnvironmentsAPI.getAvailableSources();
    const externalSourcesResponse =
      await OlgaEnvironmentsAPI.getExternalSourcesConfigs();

    setSources(sourcesResponse.getData());
    setAvailableOrigins(externalSourcesResponse.getData());

    setLoading(false);
  };

  const getSourceName = (sourceAlias) => {
    const source = sources.find((s) => s.alias == sourceAlias);
    return source ? source.name : "Desconhecido";
  };

  const ExternalSourceGroup = ({ availableOrigins }) => {
    return (
      <ForEach
        items={Object.entries(availableOrigins || {})}
        render={([sourceAlias, externalSources]) => {
          return (
            <>
              <Label text={getSourceName(sourceAlias)} className="mt-10" />
              <ExternalSourceGroupItems externalSources={externalSources} />
            </>
          );
        }}
      />
    );
  };

  const ExternalSourceGroupItems = ({ externalSources }) => {
    return (
      <ForEach
        items={Object.entries(externalSources || {})}
        render={([externalSource, config]) => (
          <Checkbox
            label={config?.correct || externalSource}
            checked={origins.includes(externalSource)}
            className={"mb-10"}
            onChange={() => {
              if (origins.includes(externalSource)) {
                setOrigins(origins.filter((f) => externalSource != f));
              } else {
                setOrigins([...origins, externalSource]);
              }
            }}
          />
        )}
      />
    );
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.OriginFilter}
    >
      {!!loading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}

      {!loading &&
        (availableOrigins ? (
          <>
            <Message className="mb-20">
              O usuário deve ter ao menos um pedido em:
            </Message>
            <p className={styles.label}>Selecione as origens</p>
            <div className={styles.scrollContainerWithFooter}>
              <ExternalSourceGroup availableOrigins={availableOrigins} />
            </div>
            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                onClick={() => onSave(getFreshNode())}
              >
                Salvar
              </Button>
            </div>
          </>
        ) : (
          <Empty
            title="Nenhuma origem encontrada"
            image={<i className="far fa-arrows-split-up-and-left"></i>}
          />
        ))}
    </Drawer>
  );
};
